@if (shouldShow) {
  <app-clearance [clearance]="clearance" clearanceKey="emas">
  </app-clearance>
}
